import React from "react";
import AddWidgetButton from "./AddWidgetButton";
import WidgetsList from "./WidgetsList";
import { useMatomo } from "@datapunt/matomo-tracker-react";
import "./WidgetsPage.scss";
import { Module } from "../../../constants";
import { generateID } from "@digitallab/grid-common-components";

const { adminWidget } = Module.PAGE.ADMIN;

export const WidgetAdd = React.createContext(<AddWidgetButton showTextOnly="True" />);

const WidgetsPage = () => {
  const { trackPageView } = useMatomo();
  React.useEffect(() => {
    trackPageView({
      documentTitle: "Admin/Widget",
      href: `${window.location?.origin}/Admin/Widget`
    });
    // eslint-disable-next-line
  }, []);
  return (
    <div className="widgets-page">
      <div className="widget-main-box" id={generateID.UUID(adminWidget, `widgetpage`, "main")}>
        <div className="header-box" id={generateID.UUID(adminWidget, `widgetpage`, "header")}>
          <div className="title" id={generateID.UUID(adminWidget, `widgetpage`, "title")}></div>
          <AddWidgetButton />
        </div>
        <WidgetsList />
      </div>
    </div>
  );
};

export default WidgetsPage;